// Nội dung trang chủ. Khi đổi giá/tên sản phẩm hoặc review, cập nhật luôn JSON-LD trong public/index.html.

export const PHONE = '0942733692';
export const PHONE_DISPLAY = '0942 733 692';
export const TEL_LINK = `tel:${PHONE}`;

export const SOCIAL_LINKS = [
  { label: 'TikTok', href: 'https://www.tiktok.com/@gakitchen49' },
  { label: 'Facebook', href: 'https://www.facebook.com/banhtrangmamruocgakitchen' },
  { label: 'Shopee', href: 'https://shopee.vn/gakitchen' },
];

export const NAV_LINKS = [
  { label: 'Sản phẩm', href: '#menu' },
  { label: 'Bán sỉ', href: '#wholesale' },
  { label: 'Đánh giá', href: '#reviews' },
  { label: 'Liên hệ', href: '#contact' },
];

const BASE_INGREDIENTS = ['Bột gạo', 'Mắm ruốc', 'Mè trắng', 'Đường mía nguyên chất', 'Ớt tươi', 'Dầu thực vật'];

// Mỗi quy cách giữ đúng tên sản phẩm cũ (dùng cho alt ảnh và khớp với Product schema).
export const PRODUCTS = [
  {
    id: 'mam',
    title: 'Bánh tráng mắm ruốc Đà Lạt',
    tag: 'Bán chạy',
    desc: 'Nướng vàng ươm, giòn rượm. Vị ngọt thanh của gạo, thơm đậm đà mắm ruốc, cay vừa đủ để thèm thêm miếng nữa.',
    ingredients: BASE_INGREDIENTS,
    sizes: [
      { label: '250gr', price: 25000, name: 'Bánh Tráng Mắm Ruốc Đặc Sản Đà Lạt - 250gr', image: 'banh-trang-mam-ruoc-250', width: 900, height: 1200 },
      { label: '125gr', price: 15000, name: 'Bánh Tráng Mắm Ruốc Đặc Sản Đà Lạt - 125gr', image: 'banh-trang-mam-ruoc-125', width: 900, height: 675 },
    ],
  },
  {
    id: 'sate',
    title: 'Bánh tráng sa tế tôm Đà Lạt',
    tag: 'Cay thơm',
    desc: 'Lớp sa tế cay nồng cùng tôm khô và hành phi thơm lừng trên nền bánh tráng nướng giòn.',
    ingredients: [...BASE_INGREDIENTS, 'Tôm khô', 'Hành phi'],
    sizes: [
      { label: '180gr', price: 29000, name: 'Bánh Tráng Sa Tế Tôm Đặc Sản Đà Lạt - 180gr', image: 'banh-trang-sate-tom-180', width: 900, height: 675 },
      { label: '90gr', price: 18000, name: 'Bánh Tráng Sa Tế Tôm Đặc Sản Đà Lạt - 90gr', image: 'banh-trang-sate-tom-90', width: 900, height: 675 },
    ],
  },
  {
    id: 'chuoi',
    title: 'Bánh phồng chuối nướng',
    tag: 'Ngọt tự nhiên',
    desc: 'Chuối xiêm chín cán mỏng trên lớp nếp, phơi nắng rồi nướng — thơm ngọt, giòn và xếp lớp vàng ươm.',
    ingredients: ['Bột mì', 'Nước dừa', 'Đường mía nguyên chất', 'Chuối xiêm chín'],
    sizes: [
      { label: '5 cái', price: 18000, name: 'Bánh Phồng Chuối Nướng - 5 cái', image: 'banh-phong-chuoi-5', width: 900, height: 674 },
      { label: '3 cái', price: 12000, name: 'Bánh Phồng Chuối Nướng - 3 cái', image: 'banh-phong-chuoi-3', width: 900, height: 674 },
    ],
  },
];

export const WHOLESALE_POLICIES = [
  'Chiết khấu hấp dẫn từ 20% – 35% tùy số lượng đặt hàng',
  'Miễn phí vận chuyển cho đơn hàng từ 5 triệu đồng',
  'Hỗ trợ in tem nhãn riêng cho đại lý',
  'Chính sách đổi trả linh hoạt trong 7 ngày',
  'Hỗ trợ tư vấn và đào tạo kỹ thuật bảo quản sản phẩm',
];

export const MIN_ORDER = [
  { name: 'Bánh tráng mắm ruốc', qty: '50 gói / lần' },
  { name: 'Bánh tráng sa tế tôm', qty: '50 gói / lần' },
  { name: 'Bánh phồng chuối', qty: '100 gói / lần' },
];

export const REVIEWS = [
  { name: 'Nguyễn Thanh Hà', initials: 'TH', date: '2026-03-15', text: 'Bánh tráng mắm ruốc ở đây rất ngon, giòn rụm và đậm đà. Mình đặt về làm quà cho người thân, ai cũng khen. Đóng gói cẩn thận, giao hàng nhanh.' },
  { name: 'Trần Minh Tuấn', initials: 'MT', date: '2026-03-10', text: 'Bánh phồng chuối nướng rất thơm ngon, vị ngọt vừa phải. Mình hay mua về ăn vặt, một gói to đùng mà giá cả phải chăng. Sẽ ủng hộ shop dài dài.' },
  { name: 'Phạm Thu Thảo', initials: 'TT', date: '2026-03-05', text: 'Bánh tráng sa tế tôm là món khoái khẩu của cả nhà. Vị cay vừa phải, tôm khô thơm lừng. Mỗi lần mua là phải mua vài gói để dự trữ.' },
  { name: 'Lê Văn Nam', initials: 'VN', date: '2026-03-01', text: 'Chất lượng sản phẩm rất tốt, đóng gói cẩn thận. Mình mua số lượng lớn về bán, khách hàng phản hồi rất tích cực. Chỉ có điều đôi khi hết hàng phải đợi.' },
  { name: 'Trần Thị Mai', initials: 'TM', date: '2026-02-28', text: 'Bánh tráng mắm ruốc size 250gr rất tiện cho gia đình mình. Giòn tan, không bị cứng hay dai. Mắm ruốc thơm nồng, vị vừa ăn. Sẽ mua lại!' },
  { name: 'Nguyễn Đức Thành', initials: 'ĐT', date: '2026-02-25', text: 'Đặt số lượng lớn cho cửa hàng, được tư vấn rất nhiệt tình. Chính sách bán sỉ hợp lý, chiết khấu tốt. Khách của mình ai cũng thích.' },
];

export const formatPrice = (value) => `${value.toLocaleString('vi-VN')}đ`;

export const formatDate = (iso) => iso.split('-').reverse().join('/');
